/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicAccessValidation extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicAccessValidation");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicAccessValidation.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicAccessValidation>): BackgroundJobPayloadForPeriodicAccessValidation {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicAccessValidation(), model);
        BackgroundJobPayloadForPeriodicAccessValidation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicAccessValidation>): BackgroundJobPayloadForPeriodicAccessValidation {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicAccessValidation.newInstance(<BackgroundJobPayloadForPeriodicAccessValidation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicAccessValidation) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicAccessValidation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicAccessValidation): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicAccessValidation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
